import { useContext, useEffect } from 'react'
import { Blocker, useBlocker } from 'react-router'
import { StoresContext } from '@App/contexts'
import { BulkActionStore, LeavePageSource } from '@App/stores/search/bulk-action-store'
import { PaginationBody } from '@Entities/pagination'

interface SearchStoreWithPagination {
    pagination: PaginationBody
}

export const useBulkActionNavigationBlocker = <TAction extends string, TSteps extends string>(
    bulkActionStore: BulkActionStore<TAction, TSteps> | undefined,
    searchStore: SearchStoreWithPagination,
    selectionLimit = 100
): Blocker => {
    const { popupStore } = useContext(StoresContext)

    const hasPendingBulkActions = bulkActionStore
        ? bulkActionStore.idsSelectedForBulkAction.size > 0 || bulkActionStore.areFilesStaged
        : false

    const selectionSize = bulkActionStore?.idsSelectedForBulkAction.size ?? 0

    const blocker = useBlocker(hasPendingBulkActions)

    useEffect(() => {
        if (blocker.state === 'blocked' && bulkActionStore) {
            bulkActionStore.setLeavePageModalOpen(searchStore.pagination, LeavePageSource.Navigation)
        }
    }, [blocker.state])

    useEffect(() => {
        if (bulkActionStore && selectionSize > selectionLimit) {
            popupStore.setAlertData(
                `You've reached the maximum number of selections. Deselect items to make changes, or submit and start a new bulk selection`,
                true
            )
        }
    }, [selectionSize])

    return blocker
}
